import { FiEdit2, FiTrash } from "react-icons/fi";

export default function BankList({ bank, id, name, number, onEdit, onDelete }) {
  return (
    <div className="p-3 border-b border-white-200 last:border-b-0">
      <h3 className="font-bold text-black-200">{bank}</h3>
      <span className="text-sm text-black-300">
        {number} an {name}
      </span>
      <div className="flex flex-wrap mt-2 gap-2">
        <button
          type="button"
          onClick={() => onEdit(id)}
          className="py-1.5 px-3 rounded-sm border border-white-300 text-sm transition-colors hover:bg-yellow-200 hover:border-yellow-300 flex items-center"
        >
          <FiEdit2 className="mr-1" />
          Edit
        </button>
        <button
          type="button"
          onClick={() => onDelete(id)}
          className="py-1.5 px-3 rounded-sm border border-white-300 text-sm transition-colors hover:bg-red-200 hover:border-red-300 hover:text-white-100 flex items-center"
        >
          <FiTrash className="mr-1" />
          Hapus
        </button>
      </div>
    </div>
  );
}
